<!-- <div class="row"> -->
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Terzo'"
	[valueInput]="element.terzo"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'importo'"
	[labelInput]="'Importo Precettato'"
	[valueInput]="element.importoPrecettato? element.importoPrecettato: ''"></div>

<!-- </div> -->